/**
 * A explicit success-or-failure value.
 *
 * Validation in this system fails for reasons a user has to see and act on: a
 * price that will not parse, a barcode that fails its check digit, a label
 * placeholder that resolves to nothing. Those are not exceptional - they are
 * expected outcomes that must reach the UI intact, so they are returned rather
 * than thrown. Exceptions stay for genuine programmer error.
 */
export function ok(value) {
    return { ok: true, value };
}
export function err(error) {
    return { ok: false, error };
}
export function isOk(result) {
    return result.ok;
}
export function isErr(result) {
    return !result.ok;
}
export function map(result, fn) {
    return result.ok ? ok(fn(result.value)) : result;
}
export function mapErr(result, fn) {
    return result.ok ? result : err(fn(result.error));
}
export function andThen(result, fn) {
    return result.ok ? fn(result.value) : result;
}
export function unwrapOr(result, fallback) {
    return result.ok ? result.value : fallback;
}
/**
 * Collect a list of results into a result of a list, failing on the first error.
 *
 * Used wherever a batch must be all-or-nothing - resolving every field on a
 * label before a byte is sent, validating every line on an order before it is
 * confirmed.
 */
export function all(results) {
    const values = [];
    for (const result of results) {
        if (!result.ok)
            return result;
        values.push(result.value);
    }
    return ok(values);
}
/**
 * Escape hatch for call sites that have already proven the value is present -
 * fixtures, tests, and code paths guarded by an earlier check. Throws otherwise,
 * because reaching here with an error is a programmer mistake, not a user one.
 */
export function expect(result, message) {
    if (result.ok)
        return result.value;
    throw new Error(`${message}: ${JSON.stringify(result.error)}`);
}
//# sourceMappingURL=result.js.map